/**
 * ErrorState - Centered error message with a retry button.
 * Use for inline error states (failed fetches, no content, etc.).
 */

import React from 'react';
import { View } from 'react-native';
import { Text } from '@gluestack-ui/themed';
import { FS_MD } from '../../theme';
import { TextLinkButton } from './TextLinkButton';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

interface ErrorStateProps {
  message: string;
  onRetry: () => void;
  retryLabel: string;
  testID?: string;
}

export const ErrorState = React.memo(function ErrorState({
  message,
  onRetry,
  retryLabel,
  testID,
}: ErrorStateProps) {
  const { theme, fontScale, ffs } = useDisplayTheme();

  return (
    <View style={{ paddingVertical: 40, alignItems: 'center', paddingHorizontal: 20 }}>
      <Text
        testID={testID}
        accessibilityRole="alert"
        allowFontScaling={false}
        style={{ fontSize: FS_MD * fontScale, color: theme.textSecondary, textAlign: 'center', ...ffs }}
      >
        {message}
      </Text>
      <View style={{ marginTop: 16 }}>
        <TextLinkButton
          testID={testID ? `${testID}-retry` : 'error-retry'}
          accessibilityRole="button"
          label={retryLabel}
          onPress={onRetry}
        />
      </View>
    </View>
  );
});
